import { Mesh, Object3D, PlaneGeometry, ShadowNodeMaterial, DirectionalLight } from 'three/webgpu'
import { types } from '@theatre/core'

export default class ShadowCatcher extends Mesh {
	static defaults = {
		size: 4,
		opacity: 0.05,
		intensity: 2.5,
		position: { x: 1.25, y: 1.25, z: 2.5 },
		reach: 2,
		blur: 1.5,
		bias: -0.0005,
		resolution: 2048,
		near: 0.1,
		far: 12,
		nudge: { nudgeMultiplier: 0.01 },
	}

	constructor(options = {}) {
		const settings = { ...ShadowCatcher.defaults, ...options }

		super(
			new PlaneGeometry(settings.size, settings.size),
			new ShadowNodeMaterial({ transparent: true, opacity: settings.opacity })
		)

		this.options = settings
		this.receiveShadow = true

		this.target = new Object3D()
		this.add(this.target)

		this.light = new DirectionalLight(0xffffff, settings.intensity)
		this.light.position.set(settings.position.x, settings.position.y, settings.position.z)
		this.light.target = this.target
		this.light.castShadow = true

		const { shadow } = this.light

		shadow.mapSize.setScalar(settings.resolution)
		shadow.camera.near = settings.near
		shadow.camera.far = settings.far
		shadow.camera.left = -settings.reach
		shadow.camera.right = settings.reach
		shadow.camera.top = settings.reach
		shadow.camera.bottom = -settings.reach
		shadow.camera.updateProjectionMatrix()
		shadow.radius = settings.blur
		shadow.bias = settings.bias

		this.add(this.light)
	}

	bindStudio(sheet) {
		if (!sheet) return

		const { opacity, intensity, position, blur, nudge } = this.options

		this.controls = sheet.object('Device / Shadow', {
			opacity: types.number(opacity, { range: [0, 1] }),
			intensity: types.number(intensity, { range: [0, 10] }),
			blur: types.number(blur, { range: [0, 20] }),
			light: types.compound({
				x: types.number(position.x, nudge),
				y: types.number(position.y, nudge),
				z: types.number(position.z, nudge),
			}),
		})

		return this.controls.onValuesChange(values => {
			this.material.opacity = values.opacity
			this.light.intensity = values.intensity
			this.light.shadow.radius = values.blur
			this.light.position.set(values.light.x, values.light.y, values.light.z)
		})
	}

	dispose() {
		this.geometry.dispose()
		this.material.dispose()
		this.light.dispose()
		this.removeFromParent()
	}
}
